
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    Header: () => import("@/components/Header.vue"),
    HeaderMobile: () => import("@/components/HeaderMobile.vue"),
    AdminMenuMobile: () => import("@/components/admin/MenuMobile.vue"),
    MenuMobile: () => import("@/components/client/MenuMobile.vue"),
    AppMenu: () => import("@/components/shared/menu/AppMenu.vue")
  },
  watch: {
    $route(to, from) {
      (this as any).init();
    }
  }
})
export default class App extends Vue {
  open: boolean = false;
  isRouteAdmin: boolean = false;
  isAuthenticated: boolean = false;
  showHeader: boolean = false;

  async beforeMount() {
    await this.authValidation();
  }

  mounted() {
    window.addEventListener("resize", () => {
      if (window.innerWidth > 992) {
        this.open = false;
      }
    });
  }

  async init() {
    await this.authValidation();
  }

  getCurrentRoute() {
    return this.$router.currentRoute.fullPath;
  }

  async authValidation() {
    let fullRoute: string = this.getCurrentRoute();
    this.isAuthenticated = await (this.$root as any).isLoggedIn();

    this.showHeader = fullRoute !== "/login" && this.isAuthenticated;

    let currentRoute: string[] = fullRoute.split("/");

    this.isRouteAdmin = currentRoute[1] === "admin";
  }
}
